
export default {
  components: {
      [process.browser && 'apexchart']: () => import('vue-apexcharts'),
    },
  props: {
    info: Object,
    colhead: {
        type: Object,
        default() {
            return { head: ['(십억원)', '2024E', '2025E', '2026E'] }
        },
    },
  },
  data() {
    return {
        chartKey: 0,
        summary: '',
        consensus: '',
        chart:[],
        chartOptions: {
          chart: { 
            type: 'line',
            height: 500,
            toolbar: {
                show: true,
            },
          },
          xaxis: {
              categories: [],
              type: 'string',
              tickAmount: 10,
          },
          yaxis: {
            tooltip: { enabled: true },
            decimalsInFloat: 2,
            title: {
              rotate: 0,
              text: '(십억원)',
              style: {
                color: '#333', 
                fontSize: '10px',
              },
              offsetX: 33, 
              offsetY: -220, 
            },     
            labels:{
              formatter: (val, index)=> { 
                val = val.toFixed(0);
                return val.replace(/\B(?=(\d{3})+(?!\d))/g, ","); }
            }           
          },
        },
    }
  },
  computed: {
    coldata() {
      const numberWithCommas = (x) => {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      };
      const billion = 1e9; // 10억 단위
      const formatSales = (year) => {
        const entry = this.info.consensus.find(item => item.year === year);
        return entry ? numberWithCommas((entry.sales / billion).toFixed(0)) : '...';
      };
      const formatOperatingIncome = (year) => {
        const entry = this.info.consensus.find(item => item.year === year);
        return entry ? numberWithCommas((entry.operatingIncome / billion).toFixed(0)) : '...';
      };
      const formatpretaxIncome = (year) => {
        const entry = this.info.consensus.find(item => item.year === year);
        return entry ? numberWithCommas((entry.pretaxIncome / billion).toFixed(0)) : '...';
      };
      const formatnetIncome = (year) => {
        const entry = this.info.consensus.find(item => item.year === year);
        return entry ? numberWithCommas((entry.netIncome / billion).toFixed(0)) : '...';
      };
      const formatcinetIncome = (year) => {
        const entry = this.info.consensus.find(item => item.year === year);
        return entry ? numberWithCommas((entry.ciNetIncome / billion).toFixed(0)) : '...';
      };
      const formattotalAsset = (year) => {
        const entry = this.info.consensus.find(item => item.year === year);
        return entry ? numberWithCommas((entry.totalAsset / billion).toFixed(0)) : '...';
      };
      const formattotalLiabilities = (year) => {
        const entry = this.info.consensus.find(item => item.year === year);
        return entry ? numberWithCommas((entry.totalLiabilities / billion).toFixed(0)) : '...';
      };
      const formattotalSTEquity = (year) => {
        const entry = this.info.consensus.find(item => item.year === year);
        return entry ? numberWithCommas((entry.totalSTEquity / billion).toFixed(0)) : '...';
      };
      const formatcitotalSTEquity = (year) => {
        const entry = this.info.consensus.find(item => item.year === year);
        return entry ? numberWithCommas((entry.citotalSTEquity / billion).toFixed(0)) : '...';
      };
      const formatoperatingCashFlow = (year) => {
        const entry = this.info.consensus.find(item => item.year === year);
        return entry ? numberWithCommas((entry.operatingCashFlow / billion).toFixed(0)) : '...';
      };
      const formatinvestCashFlow = (year) => {
        const entry = this.info.consensus.find(item => item.year === year);
        return entry ? numberWithCommas((entry.investCashFlow / billion).toFixed(0)) : '...';
      };
      const formatfinancialCashFlow = (year) => {
        const entry = this.info.consensus.find(item => item.year === year);
        return entry ? numberWithCommas((entry.finacialCashFlow / billion).toFixed(0)) : '...';
      };
      const formattotalCashFlow = (year) => {
        const entry = this.info.consensus.find(item => item.year === year);
        return entry ? numberWithCommas((entry.totalCashFlow / billion).toFixed(0)) : '...';
      };
      const formatdps = (year) => {
        const entry = this.info.consensus.find(item => item.year === year);
        return entry ? numberWithCommas((entry.dps / billion).toFixed(0)) : '...';
      };
      const formatnetDebt = (year) => {
        const entry = this.info.consensus.find(item => item.year === year);
        return entry ? numberWithCommas((entry.netDebt / billion).toFixed(0)) : '...';
      };
      const formatebitda = (year) => {
        const entry = this.info.consensus.find(item => item.year === year);
        return entry ? numberWithCommas((entry.ebitda / billion).toFixed(0)) : '...';
      };

      return [
            {category: '매출', '2024E': formatSales('2024'), '2025E': formatSales('2025'),'2026E': formatSales('2026') },
            {category: '영업이익', '2024E': formatOperatingIncome('2024'), '2025E': formatOperatingIncome('2025'),'2026E': formatOperatingIncome('2026') },
            { category: '세전이익', '2024E': formatpretaxIncome('2024'), '2025E': formatpretaxIncome('2025'),'2026E': formatpretaxIncome('2026') },
            { category: '당기순이익', '2024E': formatnetIncome('2024'), '2025E': formatnetIncome('2025'),'2026E': formatnetIncome('2026') },
            { category: '지배주주 순이익', '2024E': formatcinetIncome('2024'), '2025E': formatcinetIncome('2025'),'2026E': formatcinetIncome('2026') },
            { category: '자산총계',  '2024E': formattotalAsset('2024'), '2025E': formattotalAsset('2025'),'2026E': formattotalAsset('2026') },
            { category: '부채총계',  '2024E': formattotalLiabilities('2024'), '2025E': formattotalLiabilities('2025'),'2026E': formattotalLiabilities('2026') },
            { category: '자본총계',  '2024E': formattotalSTEquity('2024'), '2025E': formattotalSTEquity('2025'),'2026E': formattotalSTEquity('2026') },
            { category: '영업현금흐름', '2024E': formatoperatingCashFlow('2024'), '2025E': formatoperatingCashFlow('2025'),'2026E': formatoperatingCashFlow('2026') },
            { category: '투자현금흐름', '2024E': formatinvestCashFlow('2024'), '2025E': formatinvestCashFlow('2025'),'2026E': formatinvestCashFlow('2026') },
            { category: '재무현금흐름',  '2024E': formatfinancialCashFlow('2024'), '2025E': formatfinancialCashFlow('2025'),'2026E': formatfinancialCashFlow('2026') },
            { category: '총현금흐름',  '2024E': formattotalCashFlow('2024'), '2025E': formattotalCashFlow('2025'),'2026E': formattotalCashFlow('2026') },
            { category: '주당배당금',  '2024E': formatdps('2024'), '2025E': formatdps('2025'),'2026E': formatdps('2026') },
            { category: '순차입금',  '2024E': formatnetDebt('2024'), '2025E': formatnetDebt('2025'),'2026E': formatnetDebt('2026') },
            { category: 'EBITDA',  '2024E': formatebitda('2024'), '2025E': formatebitda('2025'),'2026E': formatebitda('2026') },
          ];
    },
    changee() {
        let changeVal = ''
        changeVal = this.info.summary.replaceAll('\n', '<br>')
        if(this.info.lastUpdateTime !== undefined){
          const lastUpdate = ""+this.info.lastUpdateTime
          const YYYY = lastUpdate.substring(0, 4)
          const  MM = lastUpdate.substring(4, 6)
          const  DD = lastUpdate.substring(6, 8)
    
          changeVal += "<br><br> Update : "+ YYYY + '-' + MM + '-' + DD + "<br><br>"
          changeVal += `<hr><br>`;
        }
        return changeVal
      },
      
    reportDating() {
      let changeVal = ''
      if(this.info && this.info.consensus && this.info.consensus.length > 0 && this.info.consensus[0].reportDate) {
          const dateStr = this.info.consensus[0].reportDate; // 예: "20231227"
          const year = dateStr.substring(0, 4); // 연도: "2023"
          const month = dateStr.substring(4, 6); // 월: "12"
          const day = dateStr.substring(6, 8); // 일: "27"

          changeVal += `Update : ${year}-${month}-${day}`; // "Update : 2023-12-27"
      }
      return changeVal;
    },
  },
  watch: {
    'info.chart': {
      handler(newChartData) {
        this.updateChartData(newChartData);
      },
      deep: true 
    }
  },
  created() {
    if (this.info.chart) {
      this.updateChartData(this.info.chart);
    }
  },
  methods: {
      isSpecialCategory(category) {
          return ['지배주주 순이익', '자본총계', '총현금흐름'].includes(category);
      },
      updateChartData(chartData) {
        if (Array.isArray(chartData)) {
          console.log("chartData함수내 : ", chartData);
          this.chartOptions.xaxis.categories = [];
          this.series = [
            { name: "2024", data: [] },
            { name: "2025", data: [] }
          ]; // 2024년과 2025년 데이터를 위한 시리즈 초기화

          const billion = 1e9;
          // 각 연도별로 데이터를 매핑
          
          chartData.forEach(item => {
            const year = new Date(item.year).getFullYear();
            const index = year === 2025 ? 1 : 0; // 연도별 인덱스 결정
            const value = (item.sales / billion).toFixed(0); // sales 값을 억 단위로 변환
            this.series[index].data.push(value); // 연도에 따라 데이터 추가
            this.chartOptions.xaxis.categories.push(item.reportDate); // 카테고리 추가
          });

          this.chartKey += 1; // 차트 리렌더링 트리거
        }
      },
      updateChart(indicator) {
        this.chartOptions.xaxis.categories = []
        this.series = [{ name: "2024", data: [] }, { name: "2025", data: [] }] // 2024년과 2025년 데이터를 위한 시리즈 초기화

        const categories = this.info.chart.map(item => item.reportDate);

        // 2024년과 2025년 데이터를 각각 추출하여 시리즈에 추가
        this.info.chart.forEach(item => {
          const year = new Date(item.year).getFullYear(); // 날짜에서 연도 추출
          const index = year === 2025 ? 1 : 0; // 2025년이면 인덱스 1, 그 외(2024년)는 인덱스 0
          const value = item[indicator] ? (item[indicator] / 1e9).toFixed(0) : 0; // 해당 지표 데이터 처리
          this.series[index].data.push(value); // 연도에 따라 해당 데이터 추가
        });

        this.chartOptions.xaxis.categories = categories; // 카테고리 업데이트

        this.chartKey += 1; // 리렌더링을 위한 키 값 증가
      }
  }
}
